import { sendSecureData } from 'services/secureDataSharing';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ISendSecureDataPayload } from 'services/secureDataSharing/types';

export const ThunkSendSecureDataLink = createAsyncThunk<boolean, ISendSecureDataPayload>(
  'secureDataSharing/sendSecureData',
  payload => sendSecureData(payload).then(r => r.data),
);
